import React, { useState, useEffect, useRef } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

export default function Answer({data, setAnswer, index}){
    const [value, setNewValue] = useState(data.answer);

    useEffect(() => {
        setAnswer(data.id, value)
    }, [value])

    return(
        <div className='flex flex-col'>
            <div>
                <span className='btn btn__primary-soft btn__md'>{`${index + 1}`}</span>
                <span className="font__20 answer__header">{data.text}</span>
            </div>
            <TextareaAutosize
                placeholder="Write your answer"
                onBlur={(e) => setNewValue(e.target.value)}
                name="userInput"
                defaultValue={value}
                className='resize-none mt-2 mb-4 w-[100%] pl-2 pt-1 focus:outline-none border-2'  
                minRows={4}
            />
        </div>
    )
}